module.exports = __webpack_public_path__ + "static/snow-report-background-99de1806de74d65e56beabbe6a4ae276.jpg";